export default __webpack_public_path__ + "static/media/Openening of Classes.e9e1c71b.png";